<ev-salesmap-layout>
    <div slot="left-menu" class="left-menu-base">
        @if(selectedSale() != null) {
        <commercial-sale-infocard [selectedSale]="selectedSale()"></commercial-sale-infocard>
        } @else if (showEmptyListView$ | async) {
        <div class="empty-list">
            <div class="info-icon"></div>
            <div class="header">Ingen treff</div>
            <div class="instruction">Gjør et generelt søk, juster på filtre eller zoom i kart</div>
        </div>
        }

        <commercial-sales-list [sales]="sales()?.data" [ngClass]="{ 'no-display': selectedSale() != null }"></commercial-sales-list>
    </div>
    <div slot="right-menu-buttons">
        <map-right-menu-buttons [visibleButtons]="[rightSidebarOptions.Filter]"></map-right-menu-buttons>
    </div>
    <div slot="right-menu" class="right-menu">
        @if(selectedSidebar() === rightSidebarOptions.Filter) {
        <commercial-filter></commercial-filter>
        } @else if(selectedSidebar() === rightSidebarOptions.Statistics) {
        <div>Statistikk</div>
        } @else if(selectedSidebar() === rightSidebarOptions.Favorites) {
        <div>Favorittlister</div>
        }
    </div>
</ev-salesmap-layout>
